export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4713.6112cab5.jpg";